import { Content } from "@/app-autocomplete/components/Content.tsx";
import { useAutocomplete } from "./providers/AutocompleteProvider.tsx";
import { SearchFieldInitial } from "./components/SearchFieldInitial.tsx";
import { Modal } from "./components/Modal.tsx";
import { Form } from "./components/Form.tsx";
import { Categories } from "./components/Categories.tsx";
import { Products } from "./components/Products.tsx";

export function AppAutocomplete() {
	const {
		autocomplete,
		panelRef,
		contentLayoutRef,
		categoriesLayoutRef,
        productsLayoutRef,
	} = useAutocomplete();

	return (
		<div className={`aa-autocomplete`} {...autocomplete.getRootProps({})}>
			<SearchFieldInitial />
			<Modal>
				<div className={"aa-autocomplete__layout"}>
					<header className={"aa-autocomplete__header"}>
						<a href={"/"} className={"aa-autocomplete__logo"}>
							<img alt="Aurednik logo" loading={"lazy"} width={186} height={34} src="/userdata/images/logos/logo-wordmark.svg" />
						</a>
						<div className={"aa-autocomplete__controls"}>
							<Form />
							{/*isModalOpen && <Filter/>*/}
						</div>
					</header>
					<section className="aa-PanelLayout aa-autocomplete__content" ref={panelRef} {...autocomplete.getPanelProps({})}>
						<aside className="aa-autocomplete__side" ref={categoriesLayoutRef}>
							<Categories />
						</aside>
						<div className="aa-autocomplete__results" ref={productsLayoutRef}>
							<Products />
						</div>
						<div className="aa-autocomplete__contentResult" ref={contentLayoutRef}>
							<Content />
						</div>
					</section>
					{/*
					<div className="aa-autocomplete__footer">
						{(nbProducts as number) > 0 && (
							<a href={`/${customizedUrl}/search/?input_search=${encodeURIComponent(query)}`} className="button button--primary">
								{tc.all} {nbProducts as number} {tc.showHits}
							</a>
						)}
					</div>
					*/}
				</div>
			</Modal>
		</div>
	);
}
